import { z } from '@/libs/zod';
import { PROMOTION_OFFER_TYPES } from '@/utils/promotionOffers';

export const promotionOfferSchema = z.object({
  id: z.string(),
  type: z.enum(PROMOTION_OFFER_TYPES),
  quantity: z.number(),
  percentage: z.number(),
  highlight: z.boolean(),
  title: z.string().nullable(),
  description: z.string().nullable(),
  sortOrder: z.number(),
});

export const raffleSchema = z.object({
  id: z.string(),
  tag: z.string(),
  numbering: z.number(),
  name: z.string(),
  drawDate: z.string(),
  salesEndDate: z.string(),
  maxTicketsPerCpf: z.number().nullable(),
  ticketPrice: z.number(),
  urlBanner: z.string(),
  promotionPacks: z.string().nullable(),
  promotionDescription: z.string().nullable(),
  promotionPercentage: z.number(),
  promotionTicketsAmount: z.number(),
  isPromotionAvailable: z.boolean(),
  promotionTitle: z.string(),
  urlThumbnail: z.string(),
  model: z.object({
    free: z.boolean(),
  }),
  status: z.string(),
  minTicketsPerPurchase: z.number(),
  maxTicketsPerPurchase: z.number(),
  initialTicketsAmount: z.number(),
  addTicketQuantityButtonValue: z.array(z.number()),
  addTicketButtonStepIncrement: z.number().default(1),
  addTicketButtonStepDecrement: z.number().default(1),
  urlFacebook: z.string().nullable(),
  urlWhatsapp: z.string().nullable(),
  urlTelegram: z.string().nullable(),
  redirectRaffleUrl: z.string().nullable(),
  urlSquareImage: z.string(),
  fees: z.any().nullable(),
  protocolNumber: z.string(),
  prizeValue: z.number(),
  luckySequencyType: z.string(),
});

export type Raffle = z.infer<typeof raffleSchema>;
